import React from 'react'
import './PontuacaoCard.css'

export default function PontuacaoCard({ pontuacaoTotal, pontuacaoObtida }) {
  return (
    <div className="PontuacaoCard">
      <h1>Pontuação</h1>
      <div className="PontuacaoCard-container">
        <div>
          <h2>Total</h2>
          <div>{pontuacaoTotal}</div>
        </div>
        <div>
          <h2>Obtida</h2>
          <div>{pontuacaoObtida}</div>
        </div>
      </div>
    </div>
  )
}
